import styled, { keyframes } from "styled-components";
import { FlexBox } from "./FlexBox";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerWrapper = styled(FlexBox)`
  position: relative;
  width: 100%;
  height: 100%;
`;

const Spinner = styled.div<{ size?: number; color?: string }>`
  width: ${({ size = 40 }) => size}px;
  height: ${({ size = 40 }) => size}px;
  border: 4px solid ${({ theme }) => theme.colors.verae[100]};
  border-top: 4px solid ${({ theme }) => theme.colors.verae[500]};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

interface LoadingSpinnerProps {
  size?: number;
  color?: string;
  fullScreen?: boolean;
}

export const LoadingSpinner = ({
  size,
  color,
  fullScreen,
}: LoadingSpinnerProps) => {
  return (
    <SpinnerWrapper
      justifyContent="center"
      alignItems="center"
      style={fullScreen ? { position: "fixed", top: 0, left: 0 } : undefined}
    >
      <Spinner size={size} color={color} />
    </SpinnerWrapper>
  );
};
